'use client';

import { FullPageSpinner } from '@/ui/components/FullPageSpinner';
import { CustomerInput } from '@/ui/components/customer-form/CustomerInput';
import { EnergyUsageTopNav } from '@/ui/components/customer-form/EnergyUsageTopNav';
import { FlexCustomerModal } from '@/ui/components/customer-form/FlexCustomerModal';
import { TargetOffsetModal } from '@/ui/components/customer-form/TargetOffsetModal';
import { useRequireLogin } from '@/ui/hooks/useRequireLogin';
import { signIn } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import styles from './page.module.css';

const CODE_PARAM_NAME = 'code';

export default function IndexPage() {
    const router = useRouter();
    const [checkAutoLoginDone, setCheckAutoLoginDone] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        async function checkSecretCodeAutoLogin() {
            let code = '';
            try {
                const params = new URLSearchParams(window.location.search);
                code = params.get(CODE_PARAM_NAME) as string;

                if (!code) return;

                console.log(`Trying to auto-login with code ${code}`);

                const result = await signIn('secretCode', {
                    code,
                    redirect: false,
                });

                console.log(`Auto-login result: ${JSON.stringify(result)}`);

                if (result?.error) {
                    console.error(result.error);
                    return;
                }

                // Remove the code param so that we don't retry the same login.
                const url = new URL(window.location.href);
                url.searchParams.delete(CODE_PARAM_NAME);

                // Do a full reload after login.
                router.replace(url.toString(), { scroll: false });
            } catch (e) {
                console.error(`Failed to auto-login with code ${code}: ${e}`);
            } finally {
                setCheckAutoLoginDone(true);
            }
        }

        checkSecretCodeAutoLogin();
    }, [router]);

    if (!checkAutoLoginDone) {
        return <FullPageSpinner />;
    }

    return <View />;
}

const View: React.FC = () => {
    const session = useRequireLogin();

    if (!session) {
        return <FullPageSpinner />;
    }

    return (
        <div className={styles.wrapper}>
            <EnergyUsageTopNav session={session} />
            <div className={styles.content}>
                <CustomerInput />
                <TargetOffsetModal />
                <FlexCustomerModal />
            </div>
        </div>
    );
};
